import { Box, styled } from '@mui/material';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

export const SalesBrandPermissionRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;

  & .list-bagic-line > li > .tit {
    min-width: 110px;
    width: 110px;
  }
`;

export const SalesBrandList = styled('ul')`
  margin: 0;
  padding: 0;
  list-style: none;

  & > li {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 34px;
  }
  & > li.unchecked {
    opacity: 0.4;
  }
`;

export const SalesBrandLabel = styled('label')`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #1a1a1a);
  cursor: pointer;

  &[aria-disabled='true'] {
    cursor: default;
  }
`;

export const SalesBrandActionTag = styled('span', {
  shouldForwardProp: (p) => p !== 'added',
})<{ added: boolean }>(({ added }) => ({
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: 4,
  fontSize: 12,
  lineHeight: '18px',
  ...(added
    ? {
        color: '#436FB1',
        border: '1px solid rgba(67, 111, 177, 0.24)',
        background: 'rgba(67, 111, 177, 0.12)',
      }
    : {
        color: 'var(--dk-text, #000)',
        border: '1px solid var(--dk-line, #E7E9EC)',
        background: 'rgba(231, 233, 236, 0.32)',
      }),
}));
